export default function (instance) {
  return {
    getUserPaymentCard() {
      return instance.get("api/v1/userPaymentCard/");
    },
    getUserDelivery(is_default = null) {
      return instance.get("api/v1/userDelivery/?is_default=" + is_default);
    },
    postUserDelivery(payload) {
      return instance.post("api/v1/userDelivery/", payload);
    },
    putUserDelivery(delivery_id, payload) {
      return instance.put("api/v1/userDelivery/" + delivery_id + "/", payload);
    },
    getUserOrders(payload) {
      return instance.get("api/v1/userOrders/", { params: payload });
    },
    getUserReturns(payload) {
      return instance.get("api/v1/userReturns/", { params: payload });
    },
    postUserDeliveryDoDefault(payload) {
      return instance.post("api/v1/deliveryOfUserDoDefault/", payload);
    },
    postUserPaymentDoDefault(payload) {
      return instance.post("api/v1/userPaymentCardDoDefault/", payload);
    },
    deleteUserDelivery(delivery_id) {
      return instance.delete("api/v1/userDelivery/" + delivery_id + "/");
    },
    deleteUserPaymentCard(card_id) {
      return instance.delete("api/v1/userPaymentCard/" + card_id + "/");
    },
    getUserBonus() {
      return instance.get("api/v1/userBonus/");
    },
    getUserBonusStories(payload) {
      return instance.get("api/v1/userBonusStories/", { params: payload });
    },
    getPartnerBalance() {
      return instance.get("api/v1/partnerBalance/");
    },
    putPartnerUpdate(user_id, payload) {
      return instance.put("api/v1/partnerUpdate/" + user_id + "/", payload);
    },
    postCreatePartnerPayment(payload) {
      return instance.post("api/v1/createPartnerPayment/", payload);
    },
    getGeneratorPartnerFile(partner_id) {
      return instance.get("api/v1/generatorPartnerFile/" + partner_id + "/");
    },
    getPartnerInfo() {
      return instance.get("api/v1/partnerInfo/");
    },
    getPartnerStories() {
      return instance.get("api/v1/partnerStories/");
    },
    getPartnerPayments() {
      return instance.get("api/v1/partnerPayments/");
    },
    getPartnerMultiPartners(payload) {
      return instance.get("api/v1/partnerMultiPartners/", { params: payload });
    },
    getPartnerTraining() {
      return instance.get("api/v1/partnerTraining/");
    },
    getPartnerTrainingAttempt() {
      return instance.get("api/v1/partnerTrainingAttempt/");
    },
    postPartnerTrainingAttempt(payload) {
      return instance.post("api/v1/partnerTrainingAttempt/", payload);
    },
    postPartnerTrainingAttemptSection(payload) {
      return instance.post("api/v1/partnerTrainingAttemptSection/", payload);
    },
    postPartnerTrainingAttemptSectionBlock(payload) {
      return instance.post(
        "api/v1/partnerTrainingAttemptSectionBlock/",
        payload
      );
    },
    postPartnerTrainingAttemptSectionBlockQuestion(payload) {
      return instance.post(
        "api/v1/partnerTrainingAttemptSectionBlockQuestion/",
        payload
      );
    },
    postPartnerTrainingAttemptNextBlock(payload) {
      return instance.post("api/v1/partnerTrainingAttemptNextBlock/", payload);
    },
    getTrainingMaterialTime(material_id) {
      return instance.get("api/v1/trainingMaterialTime/" + material_id + "/");
    },
    getUserNotifications() {
      return instance.get("api/v1/userNotifications/");
    },
    putUserNotifications(user_id, payload) {
      return instance.put("api/v1/userNotifications/" + user_id + "/", payload);
    },
    postPartnerRequest(payload) {
      return instance.post("api/v1/partnerRequests/", payload);
    },
    postPartnerReg(payload) {
      return instance.post("api/v1/partnerReg/", payload);
    },
    getPartnerLink() {
      return instance.get("api/v1/partnerLink/");
    },
    postPartnerLink(payload) {
      return instance.post("api/v1/partnerLink/", payload);
    },
    putRequest1111(user_id, payload) {
      return instance.put("api/v1/request1111/" + user_id + "/", payload);
    },
    postStartQuestionnaire(payload) {
      return instance.post("api/v1/startQuestionnaire/", payload);
    },
    getQuestionnaireAttempts(payload) {
      return instance.get("api/v1/questionnaireAttempts/", { params: payload });
    },
    getQuestionnaireAttempt(slug) {
      return instance.get("api/v1/questionnaireAttempt/?value=" + slug);
    },
    getQuestionnaireAttemptResult(slug) {
      return instance.get("api/v1/questionnaireAttemptResult/?value=" + slug);
    },
    getQuestionnaireAttemptBasket(slug) {
      return instance.get("api/v1/questionnaireAttemptBasket/?value=" + slug);
    },
    postQuestionnaireAttemptStory(payload) {
      return instance.post("api/v1/questionnaireAttemptStory/", payload);
    },
    postQuestionnaireAttemptCalculation(attempt_id, payload) {
      return instance.put(
        "api/v1/questionnaireAttemptCalculation/" + attempt_id + "/",
        payload
      );
    },
    postQuestionnaireAttemptCompleted(attempt_id) {
      return instance.put(
        "api/v1/questionnaireAttemptCompleted/" + attempt_id + "/"
      );
    },
    getQuestionnaireResult(attempt_id) {
      return instance.get("api/v1/questionnaireResult/" + attempt_id + "/");
    },
    getUserSubscriptions() {
      return instance.get("api/v1/userSubscriptions/");
    },
    postUserSubscriptionDetail(subscription_id, payload) {
      return instance.put(
        "api/v1/userSubscription/" + subscription_id + "/",
        payload
      );
    },
  };
}
